var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.106 9.447a1 1 0 0 1 0-.894c.14-.281.404-.75.788-1.346a20.493 20.493 0 0 1 2.251-2.89C5.661 1.631 8.62 0 12 0c3.38 0 6.339 1.632 8.855 4.316a20.493 20.493 0 0 1 2.25 2.891c.385.596.649 1.065.79 1.346a1 1 0 0 1 0 .894c-.141.281-.405.75-.79 1.346a20.493 20.493 0 0 1-2.25 2.89C18.339 16.369 15.38 18 12 18c-3.38 0-6.339-1.632-8.855-4.316a20.493 20.493 0 0 1-2.25-2.891 15.189 15.189 0 0 1-.79-1.346zm2.468.26c.575.89 1.254 1.781 2.03 2.61C6.777 14.631 9.255 16 12 16c2.745 0 5.224-1.368 7.395-3.684A18.513 18.513 0 0 0 21.86 9a18.513 18.513 0 0 0-2.464-3.316C17.224 3.368 14.745 2 12 2 9.255 2 6.776 3.368 4.605 5.684A18.513 18.513 0 0 0 2.14 9c.126.218.27.455.433.707zM12 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.792dbd7e49d3240509728103ef1c70df.svg";
export { ForwardRef as ReactComponent };